var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimelineSubmitIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    fill: "#DA9D00",
    fillOpacity: 0.1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#DA9D00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49976 12.0014H17.4998M17.4998 12.0014L12.7171 7.21875M17.4998 12.0014L12.7171 16.784",
    stroke: "#DA9D00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimelineSubmitIcon);
export default __webpack_public_path__ + "static/media/timeline_submit_icon.4bc33d7ff1620fc279fe979e7f4f3814.svg";
export { ForwardRef as ReactComponent };